import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useT } from '../i18n/LanguageContext';
import {
  buildGeneralWhatsAppMessage,
  buildWhatsAppUrl,
  hasWhatsAppNumber,
} from '../lib/whatsapp';

export default function WhatsAppButton({
  message,
  className = '',
  label,
  compact = false,
}) {
  const t = useT();

  // Sin número configurado no se renderiza nada: mejor sin botón que con un
  // enlace roto (ver frontend/.env.example).
  if (!hasWhatsAppNumber()) return null;

  const resolvedMessage = message || buildGeneralWhatsAppMessage(t);

  return (
    <a
      href={buildWhatsAppUrl(resolvedMessage)}
      target="_blank"
      rel="noreferrer"
      aria-label={t('whatsapp.aria')}
      className={`inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all ${className}`}
    >
      <MessageCircle className="w-5 h-5 flex-shrink-0" />
      {!compact && <span>{label || t('whatsapp.label')}</span>}
    </a>
  );
}
